import { render, staticRenderFns } from "./WorkspacePage.vue?vue&type=template&id=3fb01046"
import script from "./WorkspacePage.vue?vue&type=script&lang=js"
export * from "./WorkspacePage.vue?vue&type=script&lang=js"
import style0 from "./WorkspacePage.vue?vue&type=style&index=0&id=3fb01046&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports